import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { EditCollection } from '../../../shared-components'
import { CollectionApi } from "../../../api/collectionApi";

const EditCollectionContainer = (props) => {
  const [saving, setSaving] = useState(false)
  const [formErrors, setFormErrors] = useState({})
  const [collection, setCollection] = useState({
      id: 0,
      name: '',
      description: '',
      image: '',
      show_on_homepage: false,
      visible: false,
      information: '',
      text_color: '',
      background_image: ''
  })
  const params = useParams();

  useEffect(() => {
    fetchCollection();
  }, [])

  const fetchCollection = async () => {
    const collectionId = params.hasOwnProperty('id') ? + params.id : 0
    if (collectionId > 0) {
      const response = await CollectionApi.getCollection(collectionId)
      if ( response.status === 200 ) {
        setCollection(response.data)
      }
    } 
  }

  const saveCollection = async (event) => {
    event.preventDefault()
    setFormErrors({})
    if (formIsValid()) {
      setSaving(true)
      let formData = new FormData()
      for (const [field, value] of Object.entries(collection)) {
        if( value ) {
          formData.append(field, value)
        } else if ( value === false || value ==='') {
          formData.append(field, value)
        }
      }
      const urlParams = new URLSearchParams(props.location.search)
      const storeId = urlParams.get('store_id') || collection.store_id
      try {
        if(collection.id > 0) {
          await CollectionApi.updateCollection(collection.id, formData, storeId)
        } else {
          const response = await CollectionApi.createCollection(formData, storeId)
          setCollection(response.data)
          props.history.push(`/admin/collections/edit/${response.data.id}`)
        }
      }
      catch(error) {
        props.notifyActions.setErrorNotification({ message: error.response.data.message })
      }
    }
  }
  
  const formIsValid = () => {
    let formValid = true
    if (collection.name === '') {
      setFormErrors({...formErrors, name: "can't be blank"})
      formValid = false
    }
    return formValid
  }

  const removeImage = () => {
    setCollection({ ...collection, _delete_image: true })
  }

  const updateCollectionState = event => {
    const _collection = {...collection}
    if(event.target) {
      let target = event.target.name
      if ( event.target.type === 'file' && event.target.files[0] !== undefined){
        _collection[target] = event.target.files[0]
        _collection[`new_${target}`] = true
        event.target.files[0] && (_collection[`${target}_preview_url`] = URL.createObjectURL(event.target.files[0]))
      } else if (event.target.type === 'checkbox') {
        _collection[target] = event.target.checked
      } else {
        _collection[target] = event.target.value
      }
      setCollection({..._collection})
    } else {
      setCollection({...collection, information: event})
    }
  }
      
  return (
    <EditCollection 
      collection={collection}
      validationErrors={formErrors}
      isSaving={saving}
      onSave={saveCollection}
      removeImage={removeImage}
      onChange={updateCollectionState}
    />
  )
}

export default EditCollectionContainer